import { useState } from "react";

import { Button, Form, Modal } from "react-bootstrap";

import { DateTime } from "luxon";
import { Divider } from "primereact/divider";

import { dateFormatWeekday, timeFormat } from "../../../_helpers/dateHelper.ts";
import Agenda from "../../../assets/svg/Agenda.tsx";
import Chrono from "../../../assets/svg/Chrono.tsx";

const ModalValidation = ({
  address,
  appointmentDateTime,
  confirmAppointment,
  setIsValidate,
  setShow,
  show,
  service,
}: {
  address: string;
  typeLabel?: string;
  appointmentDateTime: string;
  confirmAppointment: any;
  setIsValidate: any;
  setShow: any;
  show: any;
  service: any;
}) => {
  const [accepted, setAccepted] = useState(false);
  const handleClose = () => {
    setShow(false);
  };

  const validate = () => {
    //Prepare data
    confirmAppointment();
    setIsValidate(true);
    handleClose();
  };

  const textSizeContent = { fontSize: "13px" };

  return (
    <Modal show={show} onHide={handleClose} centered={true}>
      <div className="d-flex flex-row p-3 popupHeaderConf subTitleConf justify-content-between">
        <div>
          <Agenda color={"#FFFFFF"} h={20} w={20} className={"me-2"} />
          <span>
            {(() => {
              try {
                return DateTime.fromISO(appointmentDateTime).toFormat(dateFormatWeekday);
              } catch (e) {
                console.warn("Error formatting appointment date:", e);
                return "Date à confirmer";
              }
            })()}
          </span>
        </div>
        <span>
          {(() => {
            try {
              return DateTime.fromISO(appointmentDateTime).toFormat(timeFormat);
            } catch (e) {
              console.warn("Error formatting appointment time:", e);
              return "--:--";
            }
          })()}
        </span>
      </div>

      <div className={"p-3"}>
        <div className="d-flex flex-row justify-content-between">
          <div style={textSizeContent} className="flex-column d-flex">
            <strong>{service}</strong>
            <span>{address}</span>
          </div>
          <div>
            <Chrono />
            <span className={"text-primary ms-1"}>1h</span>
          </div>
        </div>
        <Divider />
        <div className="d-flex flex-column mb-3">
          <Form.Check
            style={textSizeContent}
            type="checkbox"
            label={`En confirmant ce rendez-vous, vous vous engagez à l’honorer.`}
            checked={accepted}
            onChange={() => {
              setAccepted(!accepted);
            }}
          />
        </div>
        <Button
          disabled={!accepted}
          type="button"
          variant="success"
          className="py-3 btn-add-new w-100"
          onClick={() => validate()}
        >
          Je confirme le rendez-vous
        </Button>
      </div>
    </Modal>
  );
};

export default ModalValidation;
